import { GlobalFilterObject } from '@type/filters';


// ************************************************************************************
// Sorting (sort)
// ************************************************************************************
export const sortBy: GlobalFilterObject = {
  groupType: 'radio',
  apiParameter: 'sort',
  fields: [
    {
      label: 'order-by-relevance',
      recordOptions: {
        defaultValue: '',
        filtersLabel: 'order-by-relevance',
      },
    },
    {
      label: 'order-by-distance',
      recordOptions: {
        defaultValue: 'distance',
        filtersLabel: 'order-by-distance',
      },
    },
    {
      label: 'order-by-activity',
      recordOptions: {
        defaultValue: 'last-activity',
        filtersLabel: 'order-by-activity',
      },
    },
  ],
};


export const boardType: GlobalFilterObject = {
  groupType: 'radio',
  apiParameter: 'board',
  fields: [
    {
      label: 'board.filter.applicants.label.all',
      recordOptions: {
        defaultValue: '',
        filtersLabel: 'board.filter.applicants.label.all',
      },
    },
    {
      label: 'board.filter.applicants.label.seen',
      recordOptions: {
        defaultValue: 'seen',
        filtersLabel: 'board.filter.applicants.label.seen',
      },
    },
    {
      label: 'board.filter.applicants.label.unseen',
      recordOptions: {
        defaultValue: 'unseen',
        filtersLabel: 'board.filter.applicants.label.unseen',
      },
    },
    {
      label: 'board.filter.applicants.label.contacted',
      recordOptions: {
        defaultValue: 'contacted',
        filtersLabel: 'board.filter.applicants.label.contacted',
      },
    },
    {
      label: 'board.filter.applicants.label.uncontacted',
      recordOptions: {
        defaultValue: 'not_contacted',
        filtersLabel: 'board.filter.applicants.label.uncontacted',
      },
    },
  ],
};


// ************************************************************************************
// Career levels (careerLevels)
// ************************************************************************************
export const careerLevels:GlobalFilterObject = {
  groupType: 'checkbox',
  apiParameter: 'careerLevels',
  fields: [
    {
      label: 'global.filter.experience.none',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '0_0',
        filtersLabel: 'global.filter.experience.none',
      },
    },
    {
      label: 'global.filter.experience.entry',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '0_2',
        filtersLabel: 'global.filter.experience.entry',
      },
    },
    {
      label: 'global.filter.experience.middle',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '2_5',
        filtersLabel: 'global.filter.experience.middle',
      },
    },
    {
      label: 'global.filter.experience.senior',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '5_10',
        filtersLabel: 'global.filter.experience.senior',
      },
    },
    {
      label: 'global.filter.experience.executive',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '10_',
        filtersLabel: 'global.filter.experience.executive',
      },
    },
  ],
};


// ************************************************************************************
// Last activity (lastActivity)
// ************************************************************************************
export const lastActivity:GlobalFilterObject = {
  groupType: 'radio',
  apiParameter: 'lastActivity',
  fields: [
    {
      label: 'global.last_activity_7',
      recordOptions: {
        defaultValue: '7',
        filtersLabel: 'global.last_activity_7',
      },
    },
    {
      label: 'global.last_activity_30',
      recordOptions: {
        defaultValue: '30',
        filtersLabel: 'global.last_activity_30',
      },
    },
    {
      label: 'global.last_activity_90',
      recordOptions: {
        defaultValue: '90',
        filtersLabel: 'global.last_activity_90',
      },
    },
    {
      label: 'global.last_activity_180',
      recordOptions: {
        defaultValue: '180',
        filtersLabel: 'global.last_activity_180',
      },
    },
    {
      label: 'global.last_activity_365',
      recordOptions: {
        defaultValue: '365',
        filtersLabel: 'global.last_activity_365',
      },
    },
  ],
};


// ************************************************************************************
// Domains (domains)
// ************************************************************************************
export const domains:GlobalFilterObject = {
  groupType: 'checkbox',
  apiParameter: 'domains',
  fields: [
    {
      label: 'domain.administration',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '8',
        filtersLabel: 'domain.administration',
      },
    },
    {
      label: 'domain.agriculture',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '16',
        filtersLabel: 'domain.agriculture',
      },
    },
    {
      label: 'domain.security',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '17',
        filtersLabel: 'domain.security',
      },
    },
    {
      label: 'domain.babysitter.clean',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '12',
        filtersLabel: 'domain.babysitter.clean',
      },
    },
    {
      label: 'domain.callcenter',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '6',
        filtersLabel: 'domain.callcenter',
      },
    },
    {
      label: 'domain.construction',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '4',
        filtersLabel: 'domain.construction',
      },
    },
    {
      label: 'domain.finance',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '7',
        filtersLabel: 'domain.finance',
      },
    },
    {
      label: 'domain.education',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '13',
        filtersLabel: 'domain.education',
      },
    },
    {
      label: 'domain.engineering',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '14',
        filtersLabel: 'domain.engineering',
      },
    },
    {
      label: 'domain.it',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '9',
        filtersLabel: 'domain.it',
      },
    },
    {
      label: 'domain.legislators',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '20',
        filtersLabel: 'domain.legislators',
      },
    },
    {
      label: 'domain.management',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '19',
        filtersLabel: 'domain.management',
      },
    },
    {
      label: 'domain.marketing',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '10',
        filtersLabel: 'domain.marketing',
      },
    },
    {
      label: 'domain.medicine',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '15',
        filtersLabel: 'domain.medicine',
      },
    },
    {
      label: 'domain.production',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '5',
        filtersLabel: 'domain.production',
      },
    },
    {
      label: 'domain.hr',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '18',
        filtersLabel: 'domain.hr',
      },
    },
    {
      label: 'domain.retail',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '70',
        filtersLabel: 'domain.retail',
      },
    },
    {
      label: 'domain.beauty',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '11',
        filtersLabel: 'domain.beauty',
      },
    },
    {
      label: 'domain.transportation',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '2',
        filtersLabel: 'domain.transportation',
      },
    },
    {
      label: 'domain.technician',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '21',
        filtersLabel: 'domain.technician',
      },
    },
    {
      label: 'domain.sportart',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '24',
        filtersLabel: 'domain.sportart',
      },
    },
    {
      label: 'domain.horeca',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '3',
        filtersLabel: 'domain.horeca',
      },
    },
    {
      label: 'domain.sales',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '1',
        filtersLabel: 'domain.sales',
      },
    },
    {
      label: 'domain.others',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '23',
        filtersLabel: 'domain.others',
      },
    },
  ],
};


// ************************************************************************************
// Study levels (studyLevels)
// ************************************************************************************
export const studyLevels:GlobalFilterObject = {
  groupType: 'checkbox',
  apiParameter: 'studyLevels',
  fields: [
    {
      label: 'global.study.level.high',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '1',
        filtersLabel: 'global.study.level.high',
      },
    },
    {
      label: 'global.study.level.college',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '2',
        filtersLabel: 'global.study.level.college',
      },
    },
    {
      label: 'global.study.level.universityprogress',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '3',
        filtersLabel: 'global.study.level.universityprogress',
      },
    },
    {
      label: 'global.study.level.universitygraduate',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '4',
        filtersLabel: 'global.study.level.universitygraduate',
      },
    },
    {
      label: 'global.study.level.postuniversitary',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '5',
        filtersLabel: 'global.study.level.postuniversitary',
      },
    },
    {
      label: 'global.study.level.mba',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '6',
        filtersLabel: 'global.study.level.mba',
      },
    },
    {
      label: 'global.study.level.doctorship',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '7',
        filtersLabel: 'global.study.level.doctorship',
      },
    },
    {
      label: 'global.study.level.courses',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '8',
        filtersLabel: 'global.study.level.courses',
      },
    },
    {
      label: 'global.study.level.certifications',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '9',
        filtersLabel: 'global.study.level.certifications',
      },
    },
  ],
};


// ************************************************************************************
// Query fields (queryFields)
// search in: experience: title = 1 (QUERY_FIELD_EXPERIENCE_NAME = 1)
// search in: experience: description = 2 (QUERY_FIELD_EXPERIENCE_DESCRIPTION = 2)
// search in: experience: employer name = 3 (QUERY_FIELD_EXPERIENCE_COMPANY_NAME = 3)
// search in: experience: skills = 4 (QUERY_FIELD_SKILLS = 4)
// ************************************************************************************
export const queryFields:GlobalFilterObject = {
  groupType: 'checkbox',
  apiParameter: 'queryFields',
  fields: [
    {
      label: 'filters.search-in.query.title.label',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '1',
        filtersLabel: 'filters.search-in.query.title.label',
      },
    },
    {
      label: 'filters.search-in.query.description.label',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '2',
        filtersLabel: 'filters.search-in.query.description.label',
      },
    },
    {
      label: 'filters.search-in.query.employer-name.label',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '3',
        filtersLabel: 'filters.search-in.query.employer-name.label',
      },
    },
    {
      label: 'filters.search-in.query.skills.label',
      recordOptions: {
        valueAsArray: true,
        defaultValue: '4',
        filtersLabel: 'filters.search-in.query.skills.label',
      },
    },
  ],
};
